"use strict";

module.exports = require("regenerator-transform");


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-plugin-transform-regenerator/lib/index.js
// module id = 7Zi5
// module chunks = 0